import { Card } from "@material-ui/core";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import IconoResumenDiario from "../../../assets/icons/icono-resumen-diario.png";
import ImagenJumbo from "../../../assets/images/jumbo.png";
import { BreadCrumbsGenerico } from "../../../components/molecules/BreadCrumbsGenerico";
import { Container } from "../../../components/molecules/Container";
import NavBar from "../../../components/organisms/NavBar";
import { DialogDateRangePicker } from "./components/DialogDateRangePicker";
import { JumboMovimientosChart } from "./components/JumboMovimientosChart";
import { DateRangeContext, DateRangeContextProvider } from "./context/DateRangeContext";
import {
  RefreshContext,
  RefreshContextProvider
} from "./context/RefreshContext";
import { getJumboInfo } from "./lib/utils";

import "./OperacionesJumbosLasChispas.css";

import {
  InfoCard,
  InfoIcon,
  InfoTitle
} from "../../../components/atoms/InfoCard";
import { LeyendasMovimientos } from "../../../components/molecules/LeyendasMovimientos";
import { JumboHorometroChart } from "./components/JumboHorometroChart";
import { ZoomProvider } from "./context/ZoomContext";
import { ProduccionKpis } from "./components/ProduccionKpis/ProduccionKpis";
import {
  Button,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Tooltip
} from "@mui/material";
import IconoDumperWhite from "../../../assets/icons/dumper-white.png";
import { useHistory } from "react-router-dom";
import { JumboIcon } from "../../../components/icons/JumboIcon";
import { RefreshIcon } from "../../../components/icons/RefreshIcon";
import { calculateDaysBetweenDates } from "../../../commons/utiles";

function AmountOfDays({ isScrolled }) {
  const { finalDate } = useContext(DateRangeContext);
  const { startDate, endDate } = finalDate;
  const { t } = useTranslation();

  const amountOfDays = calculateDaysBetweenDates(startDate, endDate);

  return (
    <p
      data-is-scrolled={isScrolled}
      className="amount-of-days"
      style={{ 
        marginInlineStart: "auto",
        borderRadius: "5px",
        paddingInline: ".7rem",
        paddingBlock: ".35rem",
        color: "white",
        fontSize: "14px",
        fontWeight: "400",
        width: "165px"
      }}>{t("cantidad_dias")}: {amountOfDays + 1}</p>
  );
}

function MaquinasDrawer({ idEmpresa }) {
  const { t } = useTranslation();
  const [openDrawer, setOpenDrawer] = useState(false);
  const history = useHistory();

  const { maquinas } = getJumboInfo();

  const maquinasUnicas = maquinas.reduce(
    (acc, maquina) => {
      if (!acc.maquinas[maquina.id]) {
        acc.maquinas[maquina.id] = maquina;
      }
      if (!acc.tipos.includes(maquina.tipo)) {
        acc.tipos.push(maquina.tipo);
      }
      return acc;
    },
    { maquinas: {}, tipos: [] }
  );

  function toggleDrawer(open) {
    setOpenDrawer(open);
  }

  function redirectToMaquina(maquina) {
    localStorage.setItem(
      "dataOpMaq",
      JSON.stringify({ ...maquina, tipo: maquina.tipo })
    );
    localStorage.setItem("IdMina", maquina.id_area_operacion);

    history.push(
      `/operaciones/maquina${[3, 4, 9].includes(Number(maquina.tipo_maquina)) ? "/jumbo" : ""}`
    );
  }

  return (
    <section
      style={{
        position: "fixed",
        bottom: "15px",
        right: "28px",
        zIndex: 1000
      }}>
      <Button
        style={{
          backgroundColor: "#2f4454",
          borderRadius: "100dvw",
          padding: ".65rem"
        }}
        onClick={() => toggleDrawer(true)}>
        <img
          src={IconoDumperWhite}
          alt="dumper"
          style={{
            width: "45px"
          }}
        />
      </Button>
      <Drawer
        anchor="left"
        PaperProps={{
          style: {
            zIndex: 1501,
            background: "#2f4454",
            width: "220px"
          }
        }}
        open={openDrawer}
        onClick={() => toggleDrawer(false)}>
        <section
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "1.25rem 0",
            borderBottom: "1px solid #283c4a"
          }}>
          <p
            style={{
              color: "white",
              fontSize: "1rem",
              fontWeight: "400"
            }}>
            {t("equipos")}
          </p>
        </section>
        <List>
          {maquinasUnicas.tipos.map((tipo) => {
            const maquinasDelTipo = Object.values(
              maquinasUnicas.maquinas
            ).filter((maquina) => maquina.tipo === tipo);

            return (
              <Fragment key={tipo}>
                <div
                  style={{
                    padding: "8px 16px",
                    color: "white",
                    userSelect: "none",
                    opacity: 0.7
                  }}>
                  {tipo}s
                </div>
                <List
                  component="div"
                  disablePadding>
                  {maquinasDelTipo.map((maquina) => (
                    <ListItemButton
                      className="machine-drawer-item"
                      key={maquina.id}
                      sx={{
                        pl: 4
                      }}
                      onClick={() => redirectToMaquina(maquina)}>
                      <ListItemText
                        sx={{ color: "#f2f3f4" }}
                        primary={maquina.nombre}
                      />
                      {Number(idEmpresa) === 1 && (
                        <>
                          {maquina?.digital === 1 && (
                            <Tooltip title="Digital">
                              <small
                                style={{
                                  color: "#253440",
                                  backgroundColor: "#ffbf02",
                                  fontWeight: "bolder",
                                  paddingInline: ".5rem",
                                  borderRadius: "100dvw",
                                  marginInlineEnd: ".25rem",
                                  userSelect: "none"
                                }}>
                                D
                              </small>
                            </Tooltip>
                          )}
                          <small
                            style={{
                              color: "white",
                              backgroundColor: "#21303c",
                              padding: ".1rem .55rem",
                              borderRadius: "100dvw"
                            }}>
                            {maquina?.id}
                          </small>
                        </>
                      )}
                    </ListItemButton>
                  ))}
                </List>
              </Fragment>
            );
          })}
        </List>
      </Drawer>
    </section>
  );
}

function RefreshButton({ isScrolled }) {
  const { refreshData } = useContext(RefreshContext);

  return (
    <button
      onClick={refreshData}
      className="refresh-btn"
      data-is-scrolled={isScrolled}>
      <RefreshIcon stroke={"white"} />
    </button>
  );
}

export function OperacionesJumbosLasChispas({ idEmpresa }) {
  const { t } = useTranslation();

  const { idMaquina, digital, nombreMaquina, nombreMina, idMina, rutaMina } =
    getJumboInfo();

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 280);
    };
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section style={{ position: "relative" }}>
      <MaquinasDrawer idEmpresa={idEmpresa} />
      <NavBar />
      <Container
        maxWidth="full"
        styles={{
          position: "relative",
          padding: "0 5.5rem",
          marginTop: "2.25rem",
          display: "flex",
          flexDirection: "column",
          rowGap: "1.5rem"
        }}>
        <BreadCrumbsGenerico
          nombreMina={nombreMina}
          dataRuta={[
            { id: 1, endpoint: "/", texto: `Mine-Watch` },
            { id: 2, texto: `${t("minaSingular")} ${nombreMina}` },
            {
              id: 3,
              endpoint: `/control_diario/${rutaMina}`,
              texto: t("control_diario")
            },
            { id: 4, texto: nombreMaquina, destacar: true }
          ]}
        />
        <RefreshContextProvider>
          <DateRangeContextProvider>
            <ZoomProvider>
              <section
                data-is-scrolled={isScrolled}
                className="fixed-header-jumbo-view header-jumbo-view"
                style={{
                  backgroundColor: "#2f4454",
                  display: "flex",
                  justifyContent: "space-between",
                  position: "fixed",
                  width: "100%",
                  left: "0px",
                  top: "0px",
                  zIndex: 50
                }}>
                <section
                  className="fixed-section-actions jumbo-image-container"
                  data-is-scrolled={isScrolled}>
                  <JumboIcon />
                  <h1 className="nombre-maquina-jumbo-view">{nombreMaquina}</h1>
                  {Number(idEmpresa) === 1 && (
                    <>
                      {digital === 1 && (
                        <Tooltip title="Digital">
                          <small
                            style={{
                              color: "#253440",
                              backgroundColor: "#ffbf02",
                              fontWeight: "bolder",
                              paddingInline: ".75rem",
                              borderRadius: "100dvw",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              userSelect: "none"
                            }}>
                            D
                          </small>
                        </Tooltip>
                      )}
                      <small
                        style={{
                          color: "white",
                          backgroundColor: "#253440",
                          padding: ".1rem .55rem",
                          borderRadius: "100dvw"
                        }}>
                        {idMaquina}
                      </small>
                    </>
                  )}
                </section>
                <section
                  style={{
                    display: "flex",
                    gap: "1rem",
                    alignItems: "center"
                  }}
                  data-is-scrolled={isScrolled}
                  className="fixed-section-actions">
                  <span>
                    <AmountOfDays isScrolled={isScrolled}/>
                  </span>
                  <Tooltip
                    placement="bottom"
                    title={t("refrescar_datos")}>
                    <span>
                      <RefreshButton isScrolled={isScrolled} />
                    </span>
                  </Tooltip>
                  <Tooltip
                    placement="bottom"
                    title={t("seleccionar_rango_de_fechas")}>
                    <span>
                      <DialogDateRangePicker isScrolled={isScrolled} />
                    </span>
                  </Tooltip>
                </section>
              </section>
              {/* Normal header */}
              <section
                className="header-jumbo-view"
                style={{
                  display: "flex",
                  justifyContent: "space-between"
                }}>
                <section className="jumbo-image-container">
                  <img
                    src={ImagenJumbo}
                    alt="jumbo"
                    className="jumbo-image"
                  />
                  <h1 className="nombre-maquina-jumbo-view">{nombreMaquina}</h1>
                  {Number(idEmpresa) === 1 && (
                    <section
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "5px"
                      }}>
                      {digital === 1 && (
                        <Tooltip title="Digital">
                          <p
                            style={{
                              color: "#253440",
                              backgroundColor: "#ffbf02",
                              fontWeight: "bolder",
                              paddingInline: ".75rem",
                              borderRadius: "100dvw",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              userSelect: "none"
                            }}>
                            D
                          </p>
                        </Tooltip>
                      )}
                      <small
                        style={{
                          color: "white",
                          backgroundColor: "#2f4454",
                          padding: ".1rem .55rem",
                          borderRadius: "100dvw"
                        }}>
                        {idMaquina}
                      </small>
                    </section>
                  )}
                </section>
                <section
                  style={{
                    display: "flex",
                    gap: "1rem",
                    alignItems: "center"
                  }}>
                  <Tooltip
                    title={t("refrescar_datos")}
                    placement="top">
                    <span>
                      <RefreshButton />
                    </span>
                  </Tooltip>
                  <Tooltip
                    title={t("seleccionar_rango_de_fechas")}
                    placement="top">
                    <span>
                      <DialogDateRangePicker />
                    </span>
                  </Tooltip>
                </section>
              </section>
              <section className="general-info">
                <AmountOfDays  />
              </section>
              <Card
                style={{
                  padding: "1rem 1.5rem",
                  marginBlockStart: "-13px",
                  marginBlockEnd: "13px"
                }}>
                <section>
                  <ProduccionKpis />
                </section>
                <section>
                  <InfoCard>
                    <InfoIcon
                      style={{ width: "35px" }}
                      src={IconoResumenDiario}
                    />
                    <InfoTitle>{t("movimiento_y_horometro")}</InfoTitle>
                  </InfoCard>
                  <JumboMovimientosChart />
                  <section>
                    <section style={{ marginBlockEnd: "2rem" }}>
                      <LeyendasMovimientos idMina={idMina} />
                    </section>
                    <JumboHorometroChart />
                  </section>
                </section>
              </Card>
            </ZoomProvider>
          </DateRangeContextProvider>
        </RefreshContextProvider>
      </Container>
    </section>
  );
}
